import { useEffect, useState } from "react";
import { Video, Unlink, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { tiktokStatus, connectTikTok } from "@/lib/tiktok";
import { Button } from "@/components/ui/button";

export const TikTokAccountCard = () => {
  const [tt, setTt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { tiktokStatus(true).then(setTt); }, []);
  if (!tt || !tt.configured) return null;
  const disconnect = async () => {
    setBusy(true);
    try { await api.delete("/tiktok/disconnect"); setTt(await tiktokStatus(true)); toast.success("TikTok account disconnected — MusicFlow no longer holds a token for it."); }
    catch { toast.error("Could not disconnect TikTok"); }
    finally { setBusy(false); }
  };
  const a = tt.account;
  return (
    <div className="mb-6 flex flex-wrap items-center gap-3 rounded-xl border border-border bg-card/60 px-4 py-3" data-testid="tiktok-account-card">
      {a?.avatar_url ? <img src={a.avatar_url} alt="" className="h-9 w-9 rounded-full object-cover" /> : <span className="h-9 w-9 rounded-full bg-muted flex items-center justify-center"><Video size={16} /></span>}
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold" data-testid="tiktok-account-name">{a ? `TikTok · @${a.display_name || "connected"}` : "TikTok not connected"}</div>
        <div className="text-[11px] text-muted-foreground">{a ? `Connected ${a.connected_at ? new Date(a.connected_at).toLocaleDateString() : ""} · permissions: ${(a.scope || "").split(",").join(", ")} · videos are posted only when you click Publish` : "Link your TikTok account to publish vertical clips directly from your library."}</div>
      </div>
      {a
        ? <Button variant="outline" size="sm" onClick={disconnect} disabled={busy} className="gap-1.5 border-border" data-testid="tiktok-disconnect">{busy ? <Loader2 size={14} className="animate-spin" /> : <Unlink size={14} />} Disconnect</Button>
        : <Button variant="outline" size="sm" onClick={() => connectTikTok().catch(() => toast.error("Could not start TikTok login"))} className="gap-1.5 border-border" data-testid="tiktok-connect-card"><Video size={14} /> Connect TikTok</Button>}
    </div>
  );
};
